import React from 'react';
import { Box, Typography, Container, Link } from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = ({ hideBranding = false }) => {
  const { t } = useLanguage();

  return (
    <Box 
      component="footer" 
      sx={{ 
        backgroundColor: 'background.paper',
        borderTop: '1px solid rgba(46, 134, 171, 0.1)',
        py: 3,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        {!hideBranding && (
          <Typography 
            variant="body2" 
            color="text.primary" 
            align="center"
            sx={{ fontWeight: 300, mb: 1 }}
          >
            {t('footer.copyright')} |&nbsp;
            <Link 
              href="/contact" 
              rel="noopener noreferrer"
              sx={{ 
                color: 'text.primary',
                textDecoration: 'underline',
                '&:hover': {
                  color: 'primary.dark',
                }
              }}
            >
              {t('contact.title')}
            </Link>
          </Typography>
        )}
        <Typography 
          variant="body2" 
          color="text.primary" 
          align="center"
          sx={{ fontWeight: 300, mb: 1 }}
        >
          📍<Link 
            href="https://maps.app.goo.gl/Hg517b6tNDphaWTJ7" 
            target="_blank" 
            rel="noopener noreferrer"
            sx={{ 
              color: 'text.primary',
              textDecoration: 'underline',
              '&:hover': {
                color: 'primary.dark',
              }
            }}
          >
          Hörnesgasse 2/1, 1030 Wien
          </Link>
        </Typography>
        <Typography 
          variant="body2" 
          color="text.primary" 
          align="center"
          sx={{ fontWeight: 300 }}
        >
          <Link 
            href="/legal" 
            rel="noopener noreferrer"
            sx={{ 
              color: 'text.primary',
              textDecoration: 'underline',
              '&:hover': {
                color: 'primary.dark',
              }
            }}
          >
            {t('footer.legal')}
          </Link>
        </Typography>
        {hideBranding && (
          <div style={{ height: '60px' }}></div>
        )}
      </Container>
    </Box>
  );
};

export default Footer; 